<template>
  <div class="vx-col md:w-1/1 w-full">
    <vx-card title="Credit Limit Request">
      <!-- Filter Section -->
      <div v-if="!showDetailForm" class="vx-col w-full mb-10 ml-1 mt-5">
        <div class="vx-row w-1/2 mt-3">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Territory</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <territory-filter :full="true" :showTitle="false" />
          </div>
        </div>
        <div class="vx-row md:w-1/2 mt-3">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Customer</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <multiselect
              class="selectExample"
              v-model="selectedCustomer"
              :options="optionCustomer"
              :multiple="true"
              :allow-empty="false"
              :group-select="false"
              :max-height="160"
              :limit="4"
              placeholder="Type to search"
              :internal-search="false"
              track-by="id"
              label="code"
              @search-change="handlerSearchCustomer"
              :disabled="false"
            />
          </div>
        </div>
        <div class="vx-row md:w-1/2 mt-3">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Date</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full whitespace-no-wrap">
            <div class="mt-4 flex justify-between">
              <date-range-picker
                style="min-height: 40px"
                class="w-full"
                ref="picker"
                opens="center"
                :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy' }"
                :singleDatePicker="false"
                :timePicker="false"
                :timePicker24Hour="false"
                :showWeekNumbers="false"
                :showDropdowns="false"
                :autoApply="true"
                v-model="filterDate"
                :linkedCalendars="true"
              >
                <template v-slot:input="picker" style="min-width: 350px">
                  {{ datePickerDateFormat(picker.startDate) }} -
                  {{ datePickerDateFormat(picker.endDate) }}
                </template>
              </date-range-picker>
            </div>
          </div>
        </div>
        <div class="vx-row md:w-1/2 mt-3">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Customer Category</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <multiselect
              class="selectExample"
              v-model="selectedCustomerCategory"
              :options="optionCustomerCategory"
              :multiple="true"
              :allow-empty="false"
              :group-select="false"
              :max-height="160"
              :limit="4"
              placeholder="Type to search"
              :internal-search="false"
              track-by="ID"
              label="classification"
              @select="selectSomeCustomerCategory"
              @remove="selectSomeCustomerCategory"
              :disabled="false"
            />
          </div>
        </div>
        <div class="vx-row place-content-end mt-5 flex w-1/2 mr-10">
          <div class="mr-5">
            <vs-button
              @click="onClickBtnFilter"
              size="medium"
              color="primary"
              icon-pack="feather"
              icon="icon-search"
              title="Search"
            >
              Filter
            </vs-button>
          </div>
          <div class="mr-5">
            <vs-button
              @click="onClickBtnClearFilter"
              size="medium"
              color="primary"
              icon-pack="feather"
              icon="icon-trash-2"
              title="Search"
            >
              Clear
            </vs-button>
          </div>
        </div>
      </div>

      <!-- Close Button when in detail mode -->
      <div v-else class="mt-2 mb-4">
        <vs-button color="danger" type="border" @click="handleCloseDetail">
          Close
        </vs-button>
      </div>

      <!-- Tabs -->
      <vs-tabs v-model="selected.tab">
        <vs-tab label="Draft">
          <div class="con-tab-ejemplo">
            <list-credit-risk
              v-if="selected.tab === 0"
              ref="listDraft"
              :selected="selected"
              :option="option"
              :status="1"
              :filterData="filterData"
              @changeTab="selectedTab"
              @showDetail="handleShowDetail"
            ></list-credit-risk>
          </div>
        </vs-tab>
        <vs-tab label="Waiting">
          <div class="con-tab-ejemplo">
            <list-credit-risk
              v-if="selected.tab === 1"
              ref="listWaiting"
              :selected="selected"
              :option="option"
              :status="2"
              :filterData="filterData"
              @changeTab="selectedTab"
              @showDetail="handleShowDetail"
            ></list-credit-risk>
          </div>
        </vs-tab>
        <vs-tab label="Inquiry">
          <div class="con-tab-ejemplo">
            <list-credit-risk
              v-if="selected.tab === 2"
              ref="listInquiry"
              :selected="selected"
              :option="option"
              :status="3"
              :filterData="filterData"
              @changeTab="selectedTab"
              @showDetail="handleShowDetail"
            ></list-credit-risk>
          </div>
        </vs-tab>
        <vs-tab label="Approved">
          <div class="con-tab-ejemplo">
            <list-credit-risk
              v-if="selected.tab === 3"
              ref="listApproved"
              :selected="selected"
              :option="option"
              :status="4"
              :filterData="filterData"
              @changeTab="selectedTab"
              @showDetail="handleShowDetail"
            ></list-credit-risk>
          </div>
        </vs-tab>
        <vs-tab label="Rejected">
          <div class="con-tab-ejemplo">
            <list-credit-risk
              v-if="selected.tab === 4"
              ref="listRejected"
              :selected="selected"
              :option="option"
              :status="5"
              :filterData="filterData"
              @changeTab="selectedTab"
              @showDetail="handleShowDetail"
            ></list-credit-risk>
          </div>
        </vs-tab>
        <vs-tab label="Cancel">
          <div class="con-tab-ejemplo">
            <list-credit-risk
              v-if="selected.tab === 5"
              ref="listCancel"
              :selected="selected"
              :option="option"
              :status="6"
              :filterData="filterData"
              @changeTab="selectedTab"
              @showDetail="handleShowDetail"
            ></list-credit-risk>
          </div>
        </vs-tab>
      </vs-tabs>
    </vx-card>
  </div>
</template>

<script>
import moment from "moment";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import Multiselect from "vue-multiselect";
import list from "./list/listV2.vue";
import form from "./form/form.vue";
import territoryFilter from "../../../../components/operatingUnitFilter/territoryFilter.vue";

export default {
  components: {
    "list-credit-risk": list,
    "form-credit-risk": form,
    DateRangePicker,
    Multiselect,
    "territory-filter": territoryFilter,
  },
  data() {
    return {
      option: {},
      selected: {
        tab: 0,
      },
      showDetailForm: false,
      filterDate: {
        startDate: null,
        endDate: null,
      },
      optionCustomer: [],
      selectedCustomer: [],
      optionCustomerCategory: [],
      selectedCustomerCategory: [],
      filterKey: 0, // Add key for triggering updates
    };
  },
  computed: {
    filterData() {
      return {
        selectedCustomer: this.selectedCustomer,
        selectedCustomerCategory: this.selectedCustomerCategory,
        filterDate: this.filterDate,
        filterKey: this.filterKey, // Include filterKey to trigger reactivity
      };
    },
  },
  methods: {
    selectedTab(value = false) {
      this.selected.tab = value;
    },
    handleShowDetail(show) {
      this.showDetailForm = show;
    },
    handleCloseDetail() {
      this.showDetailForm = false;

      // Only close detail form in active tab component
      const refNames = [
        "listDraft",
        "listWaiting",
        "listInquiry",
        "listApproved",
        "listRejected",
        "listCancel",
      ];
      const activeRef = refNames[this.selected.tab];

      if (this.$refs[activeRef]) {
        this.$refs[activeRef].detail = false;
        this.$refs[activeRef].isEdit = false;
        this.$refs[activeRef].isShow = false;
      }
    },
    selectSomeCustomerCategory() {
      this.optionCustomer = [];
      this.getAllCustomerByTerritory();
    },
    getCustomerCategory() {
      this.$http
        .get("/api/v1/master/customer-category-all", {
          params: {
            order: "name",
            sort: "asc",
          },
        })
        .then((resp) => {
          if (resp.status == "success") {
            let all = {
              id: 0,
              classification: "All",
            };
            resp.data.unshift(all);
            this.optionCustomerCategory = resp.data;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getAllCustomerByTerritory(query) {
      const terr_id =
        this.$store.getters["operatingUnit/getSelectedTerritoryId"];

      let cust_cat = [];
      if (this.selectedCustomerCategory.length > 0) {
        if (this.selectedCustomerCategory[0].ID != 0) {
          cust_cat = this.selectedCustomerCategory.map((element) => element.ID);
        }
      }

      this.$http
        .get("/api/v1/master/customer-by-territories-v2", {
          params: {
            territory_id: terr_id,
            customer_category_id: cust_cat,
            search: query ? query : "",
          },
        })
        .then((resp) => {
          if (resp.status == "success") {
            let all = {
              id: 0,
              code: "All",
              name: "-",
            };
            resp.data.unshift(all);
            this.optionCustomer = resp.data;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    handlerSearchCustomer(searching) {
      this.optionCustomer = [];
      this.getAllCustomerByTerritory(searching);
    },
    onClickBtnFilter() {
      // Force reactivity by incrementing filterKey
      // This will trigger watcher in active tab component automatically
      this.$set(this, "filterKey", this.filterKey + 1);
    },
    onClickBtnClearFilter() {
      this.selectedCustomerCategory = [];
      this.selectedCustomer = [];

      // Reset to default dates
      const today = new Date();
      this.$set(
        this.filterDate,
        "startDate",
        new Date(today.getFullYear(), today.getMonth(), 1)
      );
      this.$set(
        this.filterDate,
        "endDate",
        new Date(today.getFullYear(), today.getMonth() + 1, 0)
      );

      // Trigger update - watcher will handle API call automatically
      this.$set(this, "filterKey", this.filterKey + 1);
    },
    datePickerDateFormat(date) {
      let a = null;
      if (date != null) {
        a = moment(date).format("dddd, MMMM Do YYYY");
      }
      return a;
    },
  },
  watch: {
    selectedCustomerCategory: function () {
      if (this.selectedCustomerCategory.length > 1) {
        for (let i = 0; i < this.selectedCustomerCategory.length; i++) {
          if (this.selectedCustomerCategory[i].id == 0) {
            this.selectedCustomerCategory.splice(i, 1);
          }
        }
      }
    },
    selectedCustomer: function () {
      if (this.selectedCustomer.length > 1) {
        for (let i = 0; i < this.selectedCustomer.length; i++) {
          if (this.selectedCustomer[i].id == 0) {
            this.selectedCustomer.splice(i, 1);
          }
        }
      }
    },
  },
  mounted() {
    const today = new Date();
    this.getCustomerCategory();
    this.getAllCustomerByTerritory();
    this.filterDate.startDate = new Date(
      today.getFullYear(),
      today.getMonth(),
      1
    );
    this.filterDate.endDate = new Date(
      today.getFullYear(),
      today.getMonth() + 1,
      0
    );
  },
};
</script>

<style>
@import "~vue-multiselect/dist/vue-multiselect.min.css";

/* Multiselect styles */
.selectExample {
  min-height: 40px;
}
</style>
